import Constants from "config/Constants";
import outputLogoFull from "assets/images/output-logo-horizontal-white.svg";
import outputLogoStripes from "assets/images/output-logo-180x180.svg";
import { Logo, LogoNavigation, LogoNavigationContainer } from "..";
import useSidebar from "../../SidebarProvider/useSidebar";
import { useTranslation } from "react-i18next";
import SidebarExpandCollapse from "./components/SidebarExpandCollapse";
import Div from "components/primitives/Div";

function SidebarHeader() {
  const { open } = useSidebar();
  const { t } = useTranslation();

  return (
    <LogoNavigationContainer data-sidebar="header" data-open={open}>
      <LogoNavigation to={Constants.routes.home.route}>
        <Logo data-open={open} data-size="large" src={outputLogoFull} alt={t("global.logo_alt_text")} />
        <Logo data-open={!open} data-size="small" src={outputLogoStripes} alt={t("global.logo_stripes_alt_text")} />
      </LogoNavigation>
      <Div>
        <SidebarExpandCollapse />
      </Div>
    </LogoNavigationContainer>
  );
}

export default SidebarHeader;
